import { hexToRgb } from './colorHelper'
import { contrastRatio, getDominantColor, loadHtmlImage } from './imageHelper'

// 1. Function to calculate all logos with their contrast ratios
export async function getLogosWithContrastRatios(
  bgColor: string,
  logoUrls: string[],
): Promise<{ url: string; contrast: number }[]> {
  const contrastList: { url: string; contrast: number }[] = []

  for (const logoUrl of logoUrls) {
    try {
      const htmlImage = await loadHtmlImage(logoUrl)
      const logoColor = getDominantColor(htmlImage)
      const bgColorRgb = hexToRgb(bgColor)
      const ratio = contrastRatio(bgColorRgb, logoColor)
      contrastList.push({ url: logoUrl, contrast: ratio })
    } catch (e) {
      console.warn(`Skipping logo ${logoUrl} due to error:`, e)
    }
  }

  return contrastList
}

// 2. Get best contrasting logo
export async function getBestContrastingLogo(
  bgColor: string,
  logoUrls: string[],
): Promise<string | null> {
  const contrastList = await getLogosWithContrastRatios(bgColor, logoUrls)
  if (contrastList.length === 0) return null
  contrastList.sort((a, b) => b.contrast - a.contrast)
  return contrastList[0].url
}

// 3. Get logos with contrast ratio > 1
export async function getHighContrastLogos(
  bgColor: string,
  logoUrls: string[],
  minContrast = 1,
): Promise<string[]> {
  const contrastList = await getLogosWithContrastRatios(bgColor, logoUrls)
  const filtered = contrastList
    .filter((item) => item.contrast > minContrast)
    .map((item) => item.url)

  return filtered.length > 0 ? filtered : contrastList.map((item) => item.url)
}

export function getImageAspectRatio(url: string): Promise<number> {
  return new Promise((resolve, reject) => {
    const img = new Image()
    img.onload = () => {
      const aspectRatio = img.width / img.height
      resolve(aspectRatio)
    }
    img.onerror = reject
    img.src = url
  })
}
